import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { ButtonContainer, PaypalTypographyContainer, PaypalIconContainer } from "./components/container.es.js";
function PaypalButton({
  children,
  ...rest
}) {
  return /* @__PURE__ */ jsxs(ButtonContainer, { className: "paypal-button", ...rest, children: [
    /* @__PURE__ */ jsx(PaypalTypographyContainer, { children }),
    /* @__PURE__ */ jsx(PaypalIconContainer, {})
  ] });
}
export {
  PaypalButton
};
//# sourceMappingURL=paypal-button.es.js.map
